<template>
  <div v-if="file" class="mb-4 self-center">
    <DacrBadge />
  </div>
  <template v-else>
    <Skeleton class="w-[180px] h-[46px] mb-4 self-center" />
  </template>

  <div class="flex flex-col items-center mb-4 tablet-h:mb-10">
    <div
      class="flex flex-col tablet-h:inline-block items-center tablet-h:text-center max-w-[1324px]"
    >
      <template v-if="file">
        <div
          class="font-primary font-medium text-gray-800 text-[26px] tablet-h:text-[28px] text-center [word-break:break-word] inline"
        >
          {{ file.name }}
        </div>

        <div
          v-if="isOwner"
          class="flex self-center items-center font-primary text-[14px] text-green-700 font-medium cursor-pointer mt-2.5 tablet-h:mt-0 tablet-h:ml-4 tablet-h:inline-flex"
          @click="$emit('editTitle')"
        >
          <Icon :size="18" name="Pencil" class="stroke-green-700 mr-2" />
          Edit title
        </div>
      </template>

      <Skeleton v-else class="w-[296px] h-[26px]" />
    </div>

    <Pill v-if="file?.settings.isPrivate" class="mt-2">
      Copyright is private
    </Pill>
  </div>
</template>

<script setup lang="ts">
import { Pill, Skeleton, Icon } from '@dacr/ui'
import DacrBadge from '@/assets/svg/other/DacrBadge.svg'
import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'

defineProps<{
  file?: CopyrightFile
  isOwner: boolean
}>()

defineEmits<{
  editTitle: []
}>()
</script>
